module.exports = __webpack_public_path__ + "static/media/file-illustration.12bacc40.png";